import { useDragAndDropContext } from './DragAndDropContext';
import { DragOverlayProps } from '@wix/patterns-dnd-kit-core';

export function useDefaultDragOverlayProps(): Partial<DragOverlayProps> {
  const { overlayWrapperElement } = useDragAndDropContext();

  return {
    wrapperElement: overlayWrapperElement as DragOverlayProps['wrapperElement'],
    style: {
      opacity: 0.7,
    },
  };
}
